// src/notifications/lib/notification-time.ts
// Relative "time ago" label for a notification's createdOn. 1:1 port of the
// Flutter helper `DateTimeUtils.getNotificationDateFormat`
// (scrips_core/lib/utils/date_time_utils.dart:257) with numericDates = true
// (the value the notification row passes). Same thresholds, same strings.

export function getNotificationDateFormat(createdOn: string | Date): string {
  const notificationDate = typeof createdOn === 'string' ? new Date(createdOn) : createdOn;
  const now = new Date();
  const diffMs = now.getTime() - notificationDate.getTime();
  if (Number.isNaN(diffMs)) return '';

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (days > 8) return '8 days ago';
  if (Math.floor(days / 7) >= 1) return '1 week ago';
  if (days >= 2) return `${days} days ago`;
  if (days >= 1) return '1 day ago';
  if (hours >= 2) return `${hours} hrs ago`;
  if (hours >= 1) return '1 hr ago';
  if (minutes >= 2) return `${minutes} minutes ago`;
  if (minutes >= 1) return '1 minute ago';
  if (seconds >= 10) return `${seconds} seconds ago`;
  return 'Just now';
}
